import { Button } from 'primereact/button';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Snackbar from '@material-ui/core/Snackbar';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { FormatItalic } from '@material-ui/icons';
import MuiAlert from '@material-ui/lab/Alert';
import { useFormik } from 'formik';
import React, { useEffect } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';

import * as yup from 'yup';
import { ProspectService } from '../../remote-api/api/client-services';
import {
  ClientTypeService,
  GroupTypeService,
  PrefixTypeService,
  SuffixTypeService,
} from '../../remote-api/api/master-services';
import { Box, Input, Paper } from '@material-ui/core';
import Asterisk from '../../shared-components/components/red-asterisk';

const prospectService = new ProspectService();
const grouptypeService = new GroupTypeService();
const clienttypeervice = new ClientTypeService();
const prefixservice = new PrefixTypeService();
const suffixservice = new SuffixTypeService();

const gt$ = grouptypeService.getGroupTypes();
const ct$ = clienttypeervice.getCleintTypes();
const prefx$ = prefixservice.getPrefixTypes();
const sufx$ = suffixservice.getSuffixTypes();

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const useStyles = makeStyles(theme => ({
  formBg: {
    padding: '20px',
    backgroundColor: '#fff',
    boxShadow: '0px 3px 3px -2px rgb(0 0 0 / 20%), 0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%)',
    borderRadius: '4px',
    '& .MuiFormLabel-asterisk.MuiInputLabel-asterisk': {
      color: 'red',
    },
  },
  formControl: {
    minWidth: '90%',
  },
}));
const regex = /^[\w&., \-]*$/;
const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
const validationSchema = yup.object({
  firstName: yup
    .string('Enter your First Name')
    .required('First Name is required') /* 
        .matches(regex, "Special character not allowed") */,
  lastName: yup
    .string('Enter your Last Name')
    .required('Last Name is required') /* 
        .matches(regex, "Special character not allowed") */,
  middletName: yup.string('Enter your Middle name') /* 
        .matches(regex, "Special character not allowed") */,
  mobileNo: yup
    .string('Enter your Contact No')
    .matches(phoneRegExp, 'Contact number is not valid')
    .max(10, 'Contact no. must be 10 digit')
    .min(10, 'Contact no. must be 10 digit')
    .required('Contact No is required'),
  alternateMobileNo: yup
    .string()
    .matches(phoneRegExp, 'Alternate Contact no is not valid')
    .max(10, 'Alternate Contact no. must be 10 digit')
    .min(10, 'Alternate Contact no. must be 10 digit')
    .nullable(),
  emailId: yup
    .string()
    .email('Invalid email format')
    .required('Email is required'),
  alternateEmailId: yup
    .string()
    .email('Enter a valid Email ID')
    .nullable(),
});

export default function ProspectManagementForm(props) {
  const history = useHistory();
  const query = useQuery();
  const classes = useStyles();
  const [clientTypes, setClientTypes] = React.useState([]);
  const [groupTypes, setGroupTypes] = React.useState([]);
  const [prefixes, setPrefixes] = React.useState([]);
  const [suffixes, setSuffixes] = React.useState([]);
  const [openRequired, setOpenRequired] = React.useState(false);
  const [openSnackbar, setOpenSnackbar] = React.useState(false);

  const [state, setState] = React.useState({
    prospectManagementForm: {
      clientTypeName: props.clientTypeName,
      clientType: '',
      groupType: '',
      prefix: '',
      firstName: '',
      middletName: '',
      lastName: '',
      suffix: '',
      displayName: '',
      mobileNo: '',
      alternateMobileNo: '',
      emailId: '',
      alternateEmailId: '',
      addresses: '',
      code: '',
    },
  });

  const [directors, setDirectors] = React.useState([{ fullName: '', idType: '', idNumber: '' }]);

  // Handle change for each field
  const handleDirectorChange = (index, field, value) => {
    const newDirectors = [...directors];
    newDirectors[index] = { ...newDirectors[index], [field]: value };
    setDirectors(newDirectors);
  };

  // Add new director row
  const handleAddDirector = () => {
    setDirectors([...directors, { fullName: '', idType: '', idNumber: '' }]);
  };
  const { id } = useParams();

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  const useObservable = (observable, setter, type = '') => {
    useEffect(() => {
      let subscription = observable.subscribe(result => {
        if (type === 'clientType') {
          const clType = result.content.filter(ct => ct.name == props.clientTypeName);
          if (clType.length > 0) {
            setState({
              prospectManagementForm: {
                ...state.prospectManagementForm,
                clientType: clType[0].code,
              },
            });
          }
        }
        setter(result.content);
      });
      return () => subscription.unsubscribe();
    }, [observable, setter]);
  };

  useObservable(gt$, setGroupTypes);
  useObservable(ct$, setClientTypes, 'clientType');
  useObservable(prefx$, setPrefixes);
  useObservable(sufx$, setSuffixes);

  React.useEffect(() => {
    if (id) {
      setTimeout(() => {
        populateDetails(id);
      }, 1000);
    }
  }, [id]);

  const populateDetails = id => {
    prospectService.getProspectDetails(id).subscribe(result => {
      setState({ prospectManagementForm: { ...result, addresses: result.addresses[0].addressDetails.AddressLine1 } });
      formik.setValues({ ...result, addresses: result.addresses[0].addressDetails.AddressLine1 });
    });
  };

  const handleSubmit = event => {
    // if (state.prospectManagementForm.lastName == '' && state.prospectManagementForm.clientTypeName == 'Retail') {
    //   setOpenRequired(true);
    //   return;
    // }

    const prospectParam = {
      ...state.prospectManagementForm,
      addresses: [
        {
          addressDetails: {
            AddressLine1: state.prospectManagementForm.addresses,
          },
          addressType: 'CURRENT_ADDRESS',
        },
      ],
    };

    if (state.prospectManagementForm.alternateEmailId == '') {
      prospectParam['alternateEmailId'] = null;
    }

    if (state.prospectManagementForm.alternateMobileNo == '') {
      prospectParam['alternateMobileNo'] = null;
    }

    if (id) {
      prospectParam['id'] = id;
      prospectParam['code'] = '';

      prospectService.editProspect(prospectParam, id).subscribe(ele => {
        handleClose();
      });
    } else {
      prospectService.saveProspect(prospectParam).subscribe(res => {
        // if (query.get('navigate') && res.id) {
        //   // history.push(`/${query.get('navigate')}?prospectId=${res.id}`);
        //   setOpenSnackbar(true);
        //   setTimeout(()=>{
        //     history.push(`/quotations?mode=create`);
        //   },3000)

        // } else {
        //   handleClose();
        // }
        setOpenSnackbar(true);
        setTimeout(() => {
          handleClose();
        }, 3000);
      });
    }
  };

  const handleChange = event => {
    const { name, value } = event.target;

    let dname = {};
    if (state.prospectManagementForm.clientTypeName !== 'Group') {
      if (name === 'firstName') {
        dname = {
          displayName: value + ' ' + state.prospectManagementForm.middletName + ' ' + state.prospectManagementForm.lastName,
        };
      } else if (name === 'middletName') {
        dname = {
          displayName: state.prospectManagementForm.firstName + ' ' + value + ' ' + state.prospectManagementForm.lastName,
        };
      } else if (name === 'lastName') {
        dname = {
          displayName: state.prospectManagementForm.firstName + ' ' + state.prospectManagementForm.middletName + ' ' + value,
        };
      }
    } else if (name === 'firstName') {
      dname = { displayName: value };
    }

    let clientTypeName = '';
    if (name === 'clientType') {
      const clType = clientTypes.filter(ct => ct.code == value);
      if (clType.length > 0) {
        clientTypeName = clType[0].name;
      }
    }

    setState({
      prospectManagementForm: {
        ...state.prospectManagementForm,
        [name]: value,
        ...(name === 'clientType' && { clientTypeName }),
        ...dname,
      },
    });
  };

  console.log(state);
  const handleClose = () => {
    history.push('/client/prospects?mode=viewList');

    window.location.reload();
  };

  const formik = useFormik({
    initialValues: {
      ...state.prospectManagementForm,
    },
    validationSchema: validationSchema,
    onSubmit: values => {
      // alert(JSON.stringify(values, null, 2));
      handleSubmit();
    },
  });

  const handleSnackClose = (event, reason) => {
    setOpenRequired(false);
  };
  if (state.prospectManagementForm.clientTypeName === 'Group') {
    delete formik.errors.lastName;
  }

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  useEffect(() => {
    let dName = state.prospectManagementForm.displayName.replace(/\s+/g, ' ');
    setState({
      prospectManagementForm: {
        ...state.prospectManagementForm,
        displayName: dName,
      },
    });
  }, [state.prospectManagementForm.displayName]);

  return (
    <Paper elevation="none" style={{ padding: '16px' }}>
      <Snackbar open={openSnackbar} autoHideDuration={3000} onClose={handleCloseSnackbar}>
        <Alert onClose={handleCloseSnackbar} severity="success">
          Prospect Created Succesfully !!
        </Alert>
      </Snackbar>
      <form onSubmit={formik.handleSubmit} noValidate>
        <Snackbar open={openRequired} autoHideDuration={6000} onClose={handleSnackClose}>
          <Alert onClose={handleSnackClose} severity="error">
            Please fill up Last name *
          </Alert>
        </Snackbar>
        <Grid container spacing={3} style={{ marginBottom: '20px' }}>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl className={classes.formControl}>
              <InputLabel id="demo-simple-select-label" style={{ marginBottom: '0px' }}>
                Client type <Asterisk />
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                name="clientType"
                value={state.prospectManagementForm.clientType ? state.prospectManagementForm.clientType : ''}
                onChange={handleChange}>
                {clientTypes.map(ele => {
                  return <MenuItem value={ele.code}>{ele.name}</MenuItem>;
                })}
              </Select>
            </FormControl>
          </Grid>
          {state.prospectManagementForm.clientTypeName === 'Group' && (
            <Grid item xs={12} sm={6} md={4}>
              <FormControl className={classes.formControl}>
                <InputLabel id="demo-simple-select-label" style={{ marginBottom: '0px' }}>
                  Group type
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  name="groupType"
                  value={state.prospectManagementForm.groupType}
                  onChange={handleChange}>
                  {groupTypes.map(ele => {
                    return <MenuItem value={ele.code}>{ele.name}</MenuItem>;
                  })}
                </Select>
              </FormControl>
            </Grid>
          )}
        </Grid>
        {state.prospectManagementForm.clientTypeName === 'Group' ? (
          <>
            <Grid container spacing={3} style={{ marginBottom: '20px' }}>
              <Grid item xs={12} sm={6} md={4}>
                <FormControl className={classes.formControl}>
                  <TextField
                    id="standard-basic"
                    name="firstName"
                    value={formik.values.firstName}
                    onChange={formik.handleChange}
                    onKeyUp={handleChange}
                    label="Name"
                    required
                    error={formik.touched.firstName && Boolean(formik.errors.firstName)}
                    helperText={formik.touched.firstName && formik.errors.firstName}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormControl className={classes.formControl}>
                  <TextField
                    id="standard-basic"
                    name="displayName"
                    value={state.prospectManagementForm.displayName}
                    onChange={handleChange}
                    label="Display Name"
                  />
                </FormControl>
              </Grid>
              {state.prospectManagementForm.groupType === 'GT1251630394771955712' ? (
                <Grid item xs={12} sm={6} md={4}>
                  <FormControl className={classes.formControl}>
                    <TextField
                      id="standard-basic"
                      name="code"
                      label={
                        <>
                          Code <span style={{ color: 'red' }}>*</span>
                        </>
                      }
                      //   value={basicForm.secureId}
                      //   onChange={handleBasicChange('secureId')}
                    />
                  </FormControl>
                </Grid>
              ) : null}
            </Grid>
            {state.prospectManagementForm.groupType === 'GT1251630394771955712' ? (
              <>
                <Grid container spacing={3} style={{ marginBottom: '20px' }}>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl className={classes.formControl}>
                      <InputLabel id="quote-type-label">Parent</InputLabel>
                      <Select
                        labelId="quote-type-label"
                        // value={basicForm.quoteType}
                        // onChange={handleBasicChange('quoteType')}
                        label="Parent">
                        {/* {quoteTypes?.map(item => {
                      return <MenuItem value={item?.value}>{item?.label}</MenuItem>;
                    })} */}
                        <MenuItem value="self">Self</MenuItem>
                        <MenuItem value="other">Other</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl className={classes.formControl}>
                      <TextField
                        id="standard-basic"
                        name="CorporateName"
                        label={
                          <>
                            Corporate Name <span style={{ color: 'red' }}>*</span>
                          </>
                        }
                        //   value={basicForm.secureId}
                        //   onChange={handleBasicChange('secureId')}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl className={classes.formControl}>
                      <TextField
                        id="standard-basic"
                        name="CorporateName"
                        label={
                          <>
                            Pin No <span style={{ color: 'red' }}>*</span>
                          </>
                        }
                        //   value={basicForm.secureId}
                        //   onChange={handleBasicChange('secureId')}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid container spacing={3} style={{ marginBottom: '20px' }}>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl className={classes.formControl}>
                      <TextField
                        id="standard-basic"
                        name="FaxNo"
                        label="Fax No"
                        //   value={basicForm.secureId}
                        //   onChange={handleBasicChange('secureId')}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl className={classes.formControl}>
                      <TextField
                        id="standard-basic"
                        name="AltFaxNo"
                        label="Alt Fax No"
                        //   value={basicForm.secureId}
                        //   onChange={handleBasicChange('secureId')}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl className={classes.formControl}>
                      <InputLabel id="quote-type-label">
                        Country <span style={{ color: 'red' }}>*</span>
                      </InputLabel>
                      <Select
                        labelId="quote-type-label"
                        // value={basicForm.quoteType}
                        // onChange={handleBasicChange('quoteType')}
                        label="Country">
                        {/* {quoteTypes?.map(item => {
                      return <MenuItem value={item?.value}>{item?.label}</MenuItem>;
                    })} */}
                        <MenuItem value="self">India</MenuItem>
                        <MenuItem value="other">Kenya</MenuItem>
                        <MenuItem value="other">Dubai</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid container spacing={3} style={{ marginBottom: '20px' }}>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl className={classes.formControl}>
                      <InputLabel id="quote-type-label">
                        County <span style={{ color: 'red' }}>*</span>
                      </InputLabel>
                      <Select
                        labelId="quote-type-label"
                        // value={basicForm.quoteType}
                        // onChange={handleBasicChange('quoteType')}
                        label="County">
                        {/* {quoteTypes?.map(item => {
                      return <MenuItem value={item?.value}>{item?.label}</MenuItem>;
                    })} */}
                        <MenuItem value="self">Bihar</MenuItem>
                        <MenuItem value="other">West Bengal</MenuItem>
                        <MenuItem value="other">Telangana</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl className={classes.formControl}>
                      <InputLabel id="quote-type-label">
                        City <span style={{ color: 'red' }}>*</span>
                      </InputLabel>
                      <Select
                        labelId="quote-type-label"
                        // value={basicForm.quoteType}
                        // onChange={handleBasicChange('quoteType')}
                        label="City">
                        {/* {quoteTypes?.map(item => {
                      return <MenuItem value={item?.value}>{item?.label}</MenuItem>;
                    })} */}
                        <MenuItem value="self">Hajipur</MenuItem>
                        <MenuItem value="other">Patna</MenuItem>
                        <MenuItem value="other">Nalanda</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl className={classes.formControl}>
                      <TextField
                        id="standard-basic"
                        name="postalCode"
                        label="Postal Code"
                        //   value={basicForm.secureId}
                        //   onChange={handleBasicChange('secureId')}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid container spacing={3} style={{ marginBottom: '20px' }}>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl className={classes.formControl}>
                      <TextField
                        id="standard-basic"
                        name="policeStation"
                        label="Police Station"
                        //   value={basicForm.secureId}
                        //   onChange={handleBasicChange('secureId')}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl className={classes.formControl}>
                      <TextField
                        size="small"
                        margin="dense"
                        fullWidth
                        variant="standard"
                        label="PO Box"
                        //   value={basicForm.secureId}
                        //   onChange={handleBasicChange('secureId')}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <InputLabel shrink htmlFor="corporate-logo">
                      Corporate Logo
                    </InputLabel>
                    <Input id="corporate-logo" type="file" fullWidth disableUnderline />
                  </Grid>
                </Grid>
                <Grid container spacing={3} style={{ marginBottom: '20px' }}>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl className={classes.formControl}>
                      <TextField
                        id="standard-basic"
                        name="corporateType"
                        label="Corporate Type"
                        //   value={basicForm.secureId}
                        //   onChange={handleBasicChange('secureId')}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl className={classes.formControl}>
                      <TextField
                        id="standard-basic"
                        name="industry"
                        label="Industry"
                        //   value={basicForm.secureId}
                        //   onChange={handleBasicChange('secureId')}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl className={classes.formControl}>
                      <TextField
                        type="date"
                        id="standard-basic"
                        name="dateofIncorporation"
                        label="Date of Incorporation"
                        InputLabelProps={{ shrink: true }} // 👈 this keeps label above
                      />
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid container spacing={3} style={{ marginBottom: '20px' }}>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl className={classes.formControl}>
                      <TextField
                        id="standard-basic"
                        name="incorporationCertificateNumber"
                        label="Incorporation Certificate Number"
                        //   value={basicForm.secureId}
                        //   onChange={handleBasicChange('secureId')}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl className={classes.formControl}>
                      <TextField
                        id="standard-basic"
                        name="bankAccountHolderName"
                        label="Bank Account Holder Name"
                        //   value={basicForm.secureId}
                        //   onChange={handleBasicChange('secureId')}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl className={classes.formControl}>
                      <TextField
                        id="standard-basic"
                        name="bankBranchCode"
                        label="Bank Branch Code"
                        //   value={basicForm.secureId}
                        //   onChange={handleBasicChange('secureId')}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid container spacing={3} style={{ marginBottom: '20px' }}>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl className={classes.formControl}>
                      <TextField id="standard-basic" name="bankBranchName" label="Bank Branch Name" />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl className={classes.formControl}>
                      <TextField
                        id="standard-basic"
                        name="bankAccountNumber"
                        label="Bank Account Number"
                        //   value={basicForm.secureId}
                        //   onChange={handleBasicChange('secureId')}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl className={classes.formControl}>
                      <InputLabel id="quote-type-label">Country of Incorporation</InputLabel>
                      <Select
                        labelId="quote-type-label"
                        // value={basicForm.quoteType}
                        // onChange={handleBasicChange('quoteType')}
                        label="Country">
                        {/* {quoteTypes?.map(item => {
                      return <MenuItem value={item?.value}>{item?.label}</MenuItem>;
                    })} */}
                        <MenuItem value="self">India</MenuItem>
                        <MenuItem value="other">Kenya</MenuItem>
                        <MenuItem value="other">Dubai</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid container spacing={3} style={{ marginBottom: '20px' }}>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl className={classes.formControl}>
                      <TextField
                        id="standard-basic"
                        name="accountNumber"
                        label="Account Number"
                        //   value={basicForm.secureId}
                        //   onChange={handleBasicChange('secureId')}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl className={classes.formControl}>
                      <TextField size="small" margin="dense" fullWidth variant="standard" label="Contact Person Name" />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl className={classes.formControl}>
                      <TextField
                        id="standard-basic"
                        name="contactPersonPosition"
                        label="Contact Person Position"
                        //   value={basicForm.secureId}
                        //   onChange={handleBasicChange('secureId')}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid container spacing={3} style={{ marginBottom: '20px' }}>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl className={classes.formControl}>
                      <TextField
                        id="standard-basic"
                        name="ontactPersonBusinessTelephoneNo"
                        label="Contact Person Business Telephone No"
                        //   value={basicForm.secureId}
                        //   onChange={handleBasicChange('secureId')}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl className={classes.formControl}>
                      <TextField
                        id="standard-basic"
                        name="contactPersonMobileNo"
                        label="Contact Person Mobile No"
                        //   value={basicForm.secureId}
                        //   onChange={handleBasicChange('secureId')}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl className={classes.formControl}>
                      <TextField id="standard-basic" name="contactPersonEmailAddress" label="Contact Person Email Address" />
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid container spacing={3} style={{ marginBottom: '20px' }}>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl className={classes.formControl}>
                      <TextField
                        id="standard-basic"
                        name="aMLRiskCategory"
                        label="AML Risk Category"
                        //   value={basicForm.secureId}
                        //   onChange={handleBasicChange('secureId')}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl className={classes.formControl}>
                      <TextField
                        id="standard-basic"
                        name="pepCustomer"
                        label="Pep Customer"
                        //   value={basicForm.secureId}
                        //   onChange={handleBasicChange('secureId')}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl className={classes.formControl}>
                      <TextField
                        id="standard-basic"
                        name="licenseNumber"
                        label="License Number"
                        //   value={basicForm.secureId}
                        //   onChange={handleBasicChange('secureId')}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
              </>
            ) : null}
          </>
        ) : (
          <>
            <Grid container spacing={3} style={{ marginBottom: '20px' }}>
              <Grid item xs={12} sm={6} md={4}>
                <FormControl className={classes.formControl}>
                  <InputLabel id="demo-simple-select-label" style={{ marginBottom: '0px' }}>
                    Prefix
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    name="prefix"
                    value={state.prospectManagementForm.prefix}
                    onChange={handleChange}
                    // onSelect={handleChange}
                  >
                    {prefixes.map(ele => {
                      return <MenuItem value={ele.code}>{ele.abbreviation}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormControl className={classes.formControl}>
                  <TextField
                    id="standard-basic"
                    name="firstName"
                    value={formik.values.firstName}
                    onChange={formik.handleChange}
                    onInput={e => {
                      e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                    }}
                    onKeyUp={handleChange}
                    label={
                      <span>
                        First Name <Asterisk />
                      </span>
                    }
                    // required
                    error={formik.touched.firstName && Boolean(formik.errors.firstName)}
                    helperText={formik.touched.firstName && formik.errors.firstName}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormControl className={classes.formControl}>
                  <TextField
                    id="standard-basic"
                    name="middletName"
                    value={formik.values.middletName}
                    onChange={formik.handleChange}
                    onInput={e => {
                      e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                    }}
                    onKeyUp={handleChange}
                    label="Middle Name"
                    error={formik.touched.middletName && Boolean(formik.errors.middletName)}
                    helperText={formik.touched.middletName && formik.errors.middletName}
                  />
                </FormControl>
              </Grid>
            </Grid>
            <Grid container spacing={3} style={{ marginBottom: '20px' }}>
              <Grid item xs={12} sm={6} md={4}>
                <FormControl className={classes.formControl}>
                  <TextField
                    id="standard-basic"
                    name="lastName"
                    value={formik.values.lastName}
                    onChange={formik.handleChange}
                    onInput={e => {
                      e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                    }}
                    onKeyUp={handleChange}
                    label={
                      <span>
                        Last Name <Asterisk />
                      </span>
                    }
                    // required
                    error={formik.touched.lastName && Boolean(formik.errors.lastName)}
                    helperText={formik.touched.lastName && formik.errors.lastName}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormControl className={classes.formControl}>
                  <InputLabel id="demo-simple-select-label" style={{ marginBottom: '0px' }}>
                    Suffix
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    name="suffix"
                    value={state.prospectManagementForm.suffix}
                    onChange={handleChange}
                    // onKeyUp={handleChange}
                  >
                    {suffixes.map(ele => {
                      return <MenuItem value={ele.id}>{ele.abbreviation}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormControl className={classes.formControl}>
                  <TextField
                    id="standard-basic"
                    name="displayName"
                    value={state.prospectManagementForm.displayName}
                    onChange={handleChange}
                    label="Display Name"
                    error={formik.touched.displayName && Boolean(formik.errors.displayName)}
                    helperText={formik.touched.displayName && formik.errors.displayName}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </>
        )}

        <Grid container spacing={3} style={{ marginBottom: '20px' }}>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl className={classes.formControl}>
              <TextField
                id="standard-basic"
                type="text"
                onKeyPress={event => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                name="mobileNo"
                value={formik.values.mobileNo}
                onChange={formik.handleChange}
                onKeyUp={handleChange}
                label={
                  <span>
                    Contact No <Asterisk />
                  </span>
                }
                // required
                error={formik.touched.mobileNo && Boolean(formik.errors.mobileNo)}
                helperText={formik.touched.mobileNo && formik.errors.mobileNo}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl className={classes.formControl}>
              <TextField
                id="standard-basic"
                name="emailId"
                value={formik.values.emailId.trim()}
                onChange={e => {
                  formik.setValues({ ...formik.values, emailId: e.target.value });
                  setState({
                    prospectManagementForm: {
                      ...state.prospectManagementForm,
                      emailId: e.target.value.trim(),
                    },
                  });
                }}
                // onChange={formik.handleChange}
                // onKeyUp={formik.handleChange}
                label={
                  <span>
                    Email id <Asterisk />
                  </span>
                }
                // required
                error={formik.touched.emailId && Boolean(formik.errors.emailId)}
                helperText={formik.touched.emailId && formik.errors.emailId}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl className={classes.formControl}>
              <TextField
                id="standard-basic"
                name="addresses"
                multiline
                value={formik.values.addresses}
                onChange={formik.handleChange}
                onKeyUp={handleChange}
                label="Address"
              />
            </FormControl>
          </Grid>
        </Grid>
        <Grid container spacing={3} style={{ marginBottom: '20px' }}>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl className={classes.formControl}>
              <TextField
                id="standard-basic"
                type="text"
                onKeyPress={event => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                name="alternateMobileNo"
                value={formik.values.alternateMobileNo}
                onChange={formik.handleChange}
                onKeyUp={handleChange}
                /* value={state.prospectManagementForm.alternateMobileNo}
                            onChange={handleChange} */
                label="Alt. Contact No"
                error={formik.touched.alternateMobileNo && Boolean(formik.errors.alternateMobileNo)}
                helperText={formik.touched.alternateMobileNo && formik.errors.alternateMobileNo}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl className={classes.formControl}>
              <TextField
                id="standard-basic"
                name="alternateEmailId"
                value={formik.values.alternateEmailId}
                onChange={formik.handleChange}
                onKeyUp={handleChange}
                /* value={state.prospectManagementForm.alternateEmailId}
                            onChange={handleChange} */
                label="Alt. Email id"
                error={formik.touched.alternateEmailId && Boolean(formik.errors.alternateEmailId)}
                helperText={formik.touched.alternateEmailId && formik.errors.alternateEmailId}
              />
            </FormControl>
          </Grid>
          {state.prospectManagementForm.groupType === 'GT1251630394771955712' ? (
            <Grid item xs={12} sm={6} md={4}>
              <FormControl className={classes.formControl}>
                <TextField
                  id="standard-basic"
                  name="lifeCycleStatus"
                  label="Life Cycle Status"
                  //   value={basicForm.secureId}
                  //   onChange={handleBasicChange('secureId')}
                />
              </FormControl>
            </Grid>
          ) : null}
          {query.get('mode') === 'edit' ? (
            <Grid item xs={12} sm={6} md={4}>
              <FormControl className={classes.formControl}>
                <TextField
                  id="standard-basic"
                  name="code"
                  value={formik.values.code}
                  onChange={formik.handleChange}
                  onKeyUp={handleChange}
                  label="Code"
                  disabled
                />
              </FormControl>
            </Grid>
          ) : null}
        </Grid>
        {state.prospectManagementForm.groupType === 'GT1251630394771955712' ? (
          <>
            <Box component={Paper} p={2} mb={2} elevation={6}>
              Director Details
            </Box>
            {directors.map((director, index) => (
              <Grid container spacing={4} alignItems="center" key={index} style={{ marginBottom: '10px' }}>
                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth>
                    <TextField
                      name="directorFullName"
                      label="Director Full Name"
                      value={director.fullName}
                      onChange={e => handleDirectorChange(index, 'fullName', e.target.value)}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth>
                    <TextField
                      name="directorIdType"
                      label="Director Id Type"
                      value={director.idType}
                      onChange={e => handleDirectorChange(index, 'idType', e.target.value)}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth>
                    <TextField
                      name="directorIdNumber"
                      label="Director Id Number"
                      value={director.idNumber}
                      onChange={e => handleDirectorChange(index, 'idNumber', e.target.value)}
                    />
                  </FormControl>
                </Grid>
              </Grid>
            ))}
            <Button variant="outlined" onClick={handleAddDirector}>
              Add More
            </Button>
            {/* <Grid
              container
              spacing={4}
              alignItems="center"
              style={{ display: 'flex', justifyContent: 'flex-start', padding: '15px' }}>
              <Grid item xs={12} sm={6} md={4}>
                <FormControl className={classes.formControl}>
                  <TextField
                    id="standard-basic"
                    name="directorFullName"
                    label="Director Full Name"
                    //   value={basicForm.secureId}
                    //   onChange={handleBasicChange('secureId')}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormControl className={classes.formControl}>
                  <TextField
                    id="standard-basic"
                    name="directorIdType"
                    label="Director Id Type"
                    //   value={basicForm.secureId}
                    //   onChange={handleBasicChange('secureId')}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormControl className={classes.formControl}>
                  <TextField
                    id="standard-basic"
                    name="directorIdNumber"
                    label="Director Id Number"
                    //   value={basicForm.secureId}
                    //   onChange={handleBasicChange('secureId')}
                  />
                </FormControl>
              </Grid>
              <Button variant="outlined">Add</Button>
            </Grid> */}
            <Box component={Paper} p={2} mb={2} elevation={6} style={{ marginTop: '1rem' }}>
              Contact Person Details
            </Box>
            <Grid
              container
              spacing={4}
              alignItems="center"
              style={{ display: 'flex', justifyContent: 'flex-start', padding: '15px' }}>
              <Grid item xs={12} sm={6} md={4}>
                <FormControl className={classes.formControl}>
                  <TextField
                    id="standard-basic"
                    name="phoneNo"
                    label="Phone No"
                    //   value={basicForm.secureId}
                    //   onChange={handleBasicChange('secureId')}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormControl className={classes.formControl}>
                  <TextField
                    id="standard-basic"
                    name="mobileNo"
                    //   label="Mobile No"
                    label={
                      <>
                        Mobile No <span style={{ color: 'red' }}>*</span>
                      </>
                    }
                    //   value={basicForm.secureId}
                    //   onChange={handleBasicChange('secureId')}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormControl className={classes.formControl}>
                  <TextField
                    id="standard-basic"
                    name="emailId"
                    label="Email Id"
                    //   value={basicForm.secureId}
                    //   onChange={handleBasicChange('secureId')}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </>
        ) : null}

        <Grid container spacing={3}>
          <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button variant="contained" color="secondary" style={{ marginRight: '5px' }} type="submit">
              Save
            </Button>
            <Button variant="contained" color="primary" onClick={handleClose} className="p-button-text">
              Cancel
            </Button>
          </Grid>
        </Grid>
      </form>
    </Paper>
  );
}
